// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ModalButtonWrap_modalButtonWrap__Xpv6J {\n  display: flex;\n  flex-direction: row;\n  margin-top: 2em;\n  padding: 0.5em;\n}", "",{"version":3,"sources":["webpack://./src/components/modal/modal-button-wrap/ModalButtonWrap.module.scss"],"names":[],"mappings":"AAAA;EACC,aAAA;EACA,mBAAA;EACA,eAAA;EAEA,cAAA;AAAD","sourcesContent":[".modalButtonWrap {\n\tdisplay: flex;\n\tflex-direction: row;\n\tmargin-top: 2em;\n\n\tpadding: 0.5em;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalButtonWrap": "ModalButtonWrap_modalButtonWrap__Xpv6J"
};
export default ___CSS_LOADER_EXPORT___;
